import React from "react";
import { motion } from "motion/react";
import { TestimonialsColumn } from "./testimonials-columns";

const testimonials = [
  {
    text: "Esiteck a résolu notre problème de chauffage en urgence un dimanche. Service rapide et professionnel, je recommande vivement !",
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face",
    name: "Marie Dubois",
    role: "Propriétaire, Bruxelles",
  },
  {
    text: "Intervention très rapide pour un débouchage. Technicien compétent et prix transparent. Parfait !",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
    name: "Pierre Martin",
    role: "Gérant d'immeuble, Anvers",
  },
  {
    text: "Excellent service de plomberie. Installation de notre nouvelle salle de bain réalisée dans les temps et avec soin.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face",
    name: "Sophie Laurent",
    role: "Particulier, Liège",
  },
  {
    text: "Dépannage serrurerie à 2h du matin, technicien arrivé en 30 minutes. Service d'urgence exceptionnel !",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
    name: "Jean-Luc Moreau",
    role: "Commerçant, Gand",
  },
  {
    text: "Entretien annuel de chaudière toujours impeccable. Équipe professionnelle et ponctuelle depuis 5 ans.",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face",
    name: "Catherine Leroy",
    role: "Propriétaire, Charleroi",
  },
  {
    text: "Réparation de fuite d'eau complexe résolue rapidement. Travail de qualité et garantie respectée.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face",
    name: "Michel Vandenberghe",
    role: "Syndic, Bruges",
  },
  {
    text: "Installation pompe à chaleur parfaitement réalisée. Conseils techniques précieux et suivi excellent.",
    image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop&crop=face",
    name: "Isabelle Janssen",
    role: "Architecte, Namur",
  },
  {
    text: "Service client remarquable. Devis détaillé, intervention soignée et prix respecté. Très satisfait !",
    image: "https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?w=150&h=150&fit=crop&crop=face",
    name: "François Peeters",
    role: "Entrepreneur, Louvain",
  },
  {
    text: "Débouchage canalisation avec inspection caméra. Diagnostic précis et solution durable trouvée.",
    image: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face",
    name: "Nathalie Claes",
    role: "Restauratrice, Mons",
  },
];

const firstColumn = testimonials.slice(0, 3);
const secondColumn = testimonials.slice(3, 6);
const thirdColumn = testimonials.slice(6, 9);

const TestimonialsModern = () => {
  return (
    <section className="bg-white py-24 relative overflow-hidden w-full">
      <div className="w-full px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          viewport={{ once: true }}
          className="flex flex-col items-center justify-center text-center mb-16"
        >
          <div className="flex justify-center mb-6">
            <div className="border border-blue-900 text-blue-900 py-2 px-6 rounded-full text-sm font-medium">
              Témoignages
            </div>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-blue-900 mb-6">
            Ce Que Disent Nos Clients
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed max-w-4xl">
            Plus de 2000 clients satisfaits nous font confiance pour leurs besoins en plomberie, chauffage et dépannage.
          </p>
        </motion.div>

        <div className="flex justify-center gap-6 [mask-image:linear-gradient(to_bottom,transparent,black_25%,black_75%,transparent)] max-h-[600px] overflow-hidden w-full">
          <TestimonialsColumn 
            testimonials={firstColumn} 
            duration={15}
            className="w-full max-w-xs flex-shrink-0"
          />
          <TestimonialsColumn 
            testimonials={secondColumn} 
            className="hidden md:block w-full max-w-xs flex-shrink-0" 
            duration={19} 
          />
          <TestimonialsColumn 
            testimonials={thirdColumn} 
            className="hidden lg:block w-full max-w-xs flex-shrink-0" 
            duration={17} 
          />
          <TestimonialsColumn 
            testimonials={firstColumn} 
            className="hidden xl:block w-full max-w-xs flex-shrink-0" 
            duration={21} 
          />
          <TestimonialsColumn 
            testimonials={secondColumn} 
            className="hidden 2xl:block w-full max-w-xs flex-shrink-0" 
            duration={16} 
          />
        </div>
      </div>
    </section>
  );
};

export default TestimonialsModern;